module.exports = __webpack_public_path__ + "assets/img/Jurong Lake Gardens.2d510225.jpg";